__turbopack_context__.v({
  "container": "BSGQla_container",
  "link": "BSGQla_link",
  "link--archidekt": "BSGQla_link--archidekt",
  "link--cardsphere": "BSGQla_link--cardsphere",
  "link--commander-spellbook": "BSGQla_link--commander-spellbook",
  "link--moxfield": "BSGQla_link--moxfield",
  "link--mtg-stocks": "BSGQla_link--mtg-stocks",
  "link--scryfall": "BSGQla_link--scryfall",
  "list": "BSGQla_list",
});
